export default __webpack_public_path__ + "static/media/Fashion platform architecture.c519f485.svg";